import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import GoogleLoginButton from '../components/GoogleLoginButton';

function Register() {
  const { register, user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', email: '', password: '', displayName: '', gender: '' });
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // 已登录用户直接跳转到个人资料页
  React.useEffect(() => {
    if (user) navigate('/my-profile', { replace: true });
  }, [user, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agreed) {
      setError('请先阅读并同意用户协议和隐私政策');
      return;
    }
    if (!form.gender) {
      setError('请选择性别');
      return;
    }
    setError('');
    setLoading(true);
    try {
      await register(form);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || '注册失败');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>加入 RollSleeves</h2>
        <p className="auth-subtitle">创建账户，开启你的涉外职业之旅</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">用户名 <span className="required">*</span></label>
            <input className="form-input" name="username" value={form.username} onChange={handleChange}
              placeholder="选择一个用户名" required />
          </div>
          <div className="form-group">
            <label className="form-label">显示名称</label>
            <input className="form-input" name="displayName" value={form.displayName} onChange={handleChange}
              placeholder="你希望如何被称呼" />
          </div>
          <div className="form-group">
            <label className="form-label">邮箱 <span className="required">*</span></label>
            <input className="form-input" type="email" name="email" value={form.email} onChange={handleChange}
              placeholder="your@email.com" required />
          </div>
          <div className="form-group">
            <label className="form-label">密码 <span className="required">*</span></label>
            <input className="form-input" type="password" name="password" value={form.password} onChange={handleChange}
              placeholder="至少 6 个字符" required minLength={6} />
          </div>
          <div className="form-group">
            <label className="form-label">性别 <span className="required">*</span></label>
            <select className="form-select" name="gender" value={form.gender} onChange={handleChange} required>
              <option value="">请选择（注册后不可修改）</option>
              <option value="male">男</option>
              <option value="female">女</option>
              <option value="other">其他</option>
              <option value="unspecified">保密</option>
            </select>
            <div className="form-hint" style={{ color: 'var(--text-light)', fontSize: '0.8rem', marginTop: 4 }}>
              性别信息注册后将无法修改
            </div>
          </div>

          {/* 用户协议和隐私政策勾选 */}
          <div className="form-group" style={{ marginBottom: 24 }}>
            <label style={{
              display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer',
              fontSize: '0.85rem', lineHeight: 1.6, color: 'var(--text-secondary)',
            }}>
              <input
                type="checkbox"
                checked={agreed}
                onChange={e => setAgreed(e.target.checked)}
                style={{
                  marginTop: 3, width: 18, height: 18, flexShrink: 0,
                  accentColor: 'var(--primary)', cursor: 'pointer',
                }}
              />
              <span>
                我已阅读并同意{' '}
                <Link to="/terms" target="_blank" style={{ color: 'var(--primary)', textDecoration: 'underline' }}>
                  用户协议
                </Link>
                {' '}和{' '}
                <Link to="/privacy" target="_blank" style={{ color: 'var(--primary)', textDecoration: 'underline' }}>
                  隐私政策
                </Link>
              </span>
            </label>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg"
            style={{ width: '100%', opacity: agreed ? 1 : 0.5 }}
            disabled={loading || !agreed}
          >
            {loading ? '注册中...' : '创建账户'}
          </button>
        </form>

        <GoogleLoginButton onError={setError} />

        <p className="auth-footer">
          已有账户？<Link to="/login">登录</Link>
        </p>
      </div>
    </div>
  );
}

export default Register;
